import {
	UPDATE_FILTER_PRODUCT_VARIANT,
	SET_FILTER_PRODUCT_VARIANT,
	RESET_FILTER_PRODUCT_VARIANT,
	ADD_BATCH_LIST,
	EDIT_BATCH_LIST_ITEM,
	REMOVE_BATCH_LIST_ITEM,
	ADD_BATCH_LIST_ITEM_ROW,
	UPDATE_BATCH_FORM,
} from './filterProductVariants.actions';

// utils
import _uniqueId from 'lodash/uniqueId';

const defaultState = {
	data: {
		defaultFilterProductVariant: {},
		batchForm: {},
		batchList: [
			{
				identifier: _uniqueId('row-'),
			},
		],
	},
};

function reducer(state = defaultState, action) {
	const { type, payload } = action;

	switch (type) {
		case SET_FILTER_PRODUCT_VARIANT: {
			return {
				data: {
					defaultFilterProductVariant: payload,
				},
			};
		}

		case UPDATE_FILTER_PRODUCT_VARIANT: {
			return {
				data: {
					defaultFilterProductVariant: {
						...state.data.defaultFilterProductVariant,
						...payload,
					},
				},
			};
		}

		case RESET_FILTER_PRODUCT_VARIANT: {
			return {
				...defaultState,
			};
		}

		case UPDATE_BATCH_FORM: {
			return {
				...state,
				data: {
					...state.data,
					batchForm: payload,
				},
			};
		}

		case ADD_BATCH_LIST: {
			return {
				...state,
				data: {
					...state.data,
					batchList: payload,
				},
			};
		}

		case EDIT_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.map((entry) => {
						if (entry.identifier === payload.identifier) return payload;
						return entry;
					}),
				},
			};
		}

		case REMOVE_BATCH_LIST_ITEM: {
			return {
				...state,
				data: {
					...state.data,
					batchList: state.data.batchList.filter(
						(entry) => entry.identifier !== payload
					),
				},
			};
		}

		case ADD_BATCH_LIST_ITEM_ROW: {
			return {
				...state,
				data: {
					...state.data,
					batchList: [
						...state.data.batchList,
						{
							...defaultState.data.batchList[0],
							identifier: _uniqueId('row-'),
						},
					],
				},
			};
		}

		default:
			return state;
	}
}

export default reducer;
